var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelojUpsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_4981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8727 37.4993H38.373V14.0333C38.373 12.7494 37.3387 11.7152 36.0549 11.7152C34.771 11.7152 33.7368 12.7494 33.7368 14.0333V39.8174C33.7368 41.1012 34.771 42.1355 36.0549 42.1355H50.8727C52.1566 42.1355 53.1908 41.1012 53.1908 39.8174C53.1908 38.5335 52.1566 37.4993 50.8727 37.4993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 0C16.601 0 0 16.601 0 37C0 57.399 16.601 74 37 74C57.399 74 74 57.399 74 37C74 16.601 57.399 0 37 0ZM37 69.3639C19.1508 69.3639 4.63614 54.8492 4.63614 37C4.63614 19.1508 19.1508 4.63614 37 4.63614C54.8492 4.63614 69.3639 19.1508 69.3639 37C69.3639 54.8492 54.8492 69.3639 37 69.3639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_4981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelojUpsIcon);
export default __webpack_public_path__ + "static/media/relojUpsIcon.077523c261bbe8823614140291d7307a.svg";
export { ForwardRef as ReactComponent };